<template>
  <table class="o-table o-table--fixed c-table--results">
    <thead>
    <tr>
      <th class="c-table-cell__valign-bottom" rowspan="2">
        <div class="c-table__cell-content">
          {{$t('import.type')}}
        </div>
      </th>
      <th colspan="2">
        {{$t('import.prepared')}}
      </th>
      <th colspan="2">
        {{$t('import.processed')}}
      </th>
    </tr>
    <tr>
      <th class="c-table-cell__valign-bottom is-first">
        {{$t('import.new')}}
      </th>
      <th class="c-table-cell__valign-bottom">
        {{$t('import.update')}}
      </th>
      <th class="c-table-cell__valign-bottom">
        {{$t('import.finished')}}
      </th>
      <th class="c-table-cell__valign-bottom">
        {{$t('import.error')}}
      </th>
      <th class="c-table-cell__valign-bottom is-first">
        {{$t('import.details')}}
      </th>
    </tr>
    </thead>
    <tbody class="c-table__body">
    <sectionSummary v-for="section of importItem.sections" :key="section" :section="section"/>
    </tbody>
  </table>
</template>

<script>
  import find from "lodash/find";

  export default {
    name: "import-view-summary",
    components: {
      sectionSummary: require('./viewSummarySection.vue').default,
    },
    computed: {
      importItem: function() {
        return find(this.$store.state.imports.items, item => item.id === this.$route.params.importId)
      },
    },
  }
</script>
